import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import PollIcon from "@material-ui/icons/Poll";
import IconButton from "@material-ui/core/IconButton";
import PrintIcon from "@material-ui/icons/Print";
import ShareIcon from "@material-ui/icons/Share";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import MUITooltip from "@material-ui/core/Tooltip";

import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import TinyChart from "./TinyChart";

import OPKTable2 from "./OPKTable2";
import ProfitTable from "./ProfitTable";
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import { apiurl } from '../app/prefs.js';
import MonthSelect from "./MonthSelection";

import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import { Dialog, DialogContent } from '@material-ui/core';
import { Popover } from "@material-ui/core";

const VideoIcon = (props) => (
  <svg
      class="svg-icon"
      width='26px'
      height='26px'
      color='#0b6471'
      viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M725.333333 574.506667l170.666667 113.770666V335.722667l-170.666667 113.770666v125.013334z m0-227.562667l189.653334-126.442667C943.36 201.6 981.333333 221.930667 981.333333 256v512c0 34.069333-37.973333 54.4-66.346666 35.498667L725.333333 677.056v48.106667C725.333333 784.085333 677.504 832 618.752 832H149.248A106.666667 106.666667 0 0 1 42.666667 725.162667V298.837333C42.666667 239.914667 90.496 192 149.248 192h469.504A106.666667 106.666667 0 0 1 725.333333 298.837333v48.106667zM128 298.837333v426.325334A21.333333 21.333333 0 0 0 149.248 746.666667h469.504c11.584 0 21.248-9.685333 21.248-21.504V298.837333A21.333333 21.333333 0 0 0 618.752 277.333333H149.248C137.664 277.333333 128 287.018667 128 298.837333z" fill="#0b6471" /></svg>
)

const PlayIcon = () => (
  <svg width="40px" height="40px" viewBox="-1 0 14 14" id="meteor-icon-kit__solid-play-s" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.00154V13.0015C0 13.7788 0.84797 14.259 1.5145 13.859L11.5145 7.859C12.1618 7.4706 12.1618 6.5325 11.5145 6.1441L1.5145 0.14405C0.84797 -0.25586 0 0.22425 0 1.00154z" fill="#758CA3"></path></g></svg>
)

function DriverTargets(props) {
  const { row } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  React.useEffect(
    () => {
      setPage(0)
    }, [row]
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const CustomTooltip = (props) => {
    const { active } = props;
    if (active) {
      const { payload, label } = props;
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "rgba(100,100,100,0.8)",
            color: "white",
            padding: "3px",
            borderRadius: "5px",
          }}
        >
          <p className="label">{`${label} : ${payload[0].value.toLocaleString(
            "pl-PL",
            { maximumFractionDigits: 0 }
          )}`}</p>
        </div>
      );
    } else return null;
  };

  return (
    <Paper
      style={{
        minWidth: "410px",
        width: "100%",
        padding: "5px",
        marginBottom: "10px",
        marginRight: "0px",
      }}
    >
      <Typography
        style={{
          color: "#0b6471",
          fontSize: "16px",
          fontWeight: "100",
          borderBottom: "0px solid",
          paddingLeft: "10px",
          paddingTop: "5px",
        }}
      >
        ANALIZA ROZLICZENIA KOSZTÓW OPK POMOCNICZEGO
      </Typography>

      <TableContainer>
        <Table size="small" style={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                }}
              >
                OPK Docelowe
              </TableCell>
              <TableCell
                align="center"
                colSpan='2'
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                }}
              >
                WYK Liczba jednostek klucza
              </TableCell>

              <TableCell
                align="center"
                colSpan='2'
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                }}
              >
                WYK Koszt rozliczony
              </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {row &&
              row
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((child) => (
                  <TableRow key={child.opk_id} hover={true}>
                    <TableCell component="th" scope="row">
                      {child.opk_name}
                    </TableCell>
                    <TableCell align="right">
                      {child.wqty.toLocaleString("pl-PL", {
                        maximumFractionDigits: 0,
                      })}
                    </TableCell>
                    <TableCell style={{ padding: "0px" }}>
                      <div
                        style={{
                          height: "40px",
                          width: "130px",
                          padding: "0px",
                        }}
                      >
                        <ResponsiveContainer>
                          <BarChart
                            style={{ padding: "0px", margin: "0px" }}
                            width={250}
                            height={60}
                            data={child.monthly}
                          >
                            <Tooltip content={<CustomTooltip />} />
                            <XAxis dataKey="MONTH" hide={true} />
                            <Bar
                              dataKey="wqty"
                              fill="#0B6471"
                              barSize={250 / (1.5 * 12)}
                            >
                              {child.monthly.map((entry, index) => (
                                <Cell
                                  key={index}
                                  cursor="pointer"
                                  fill={entry.wqty < 0 ? "#FE8E3C" : "#0B6471"}
                                />
                              ))}
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      {child.cost_indirect.toLocaleString("pl-PL", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                      })}
                    </TableCell>
                    <TableCell style={{ padding: "0px" }}>
                      <div
                        style={{
                          height: "40px",
                          width: "130px",
                          padding: "0px",
                        }}
                      >
                        <ResponsiveContainer>
                          <BarChart
                            style={{ padding: "0px", margin: "0px" }}
                            width={250}
                            height={60}
                            data={child.monthly}
                          >
                            <Tooltip content={<CustomTooltip />} />
                            <XAxis dataKey="MONTH" hide={true} />
                            <Bar
                              dataKey="cost_indirect"
                              fill="#4E97A5"
                              barSize={250 / (1.5 * 12)}
                            >
                              {child.monthly.map((entry, index) => (
                                <Cell
                                  cursor="pointer"
                                  fill={entry.cost_indirect < 0 ? "#FE8E3C" : "#4E97A5  "}
                                />
                              ))}
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 20]}
          component="div"
          count={row && row.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Paper>
  );
}

function DriverSummary(props) {
  const { row } = props;

  const CustomTooltip = (props) => {
    const { active } = props;
    if (active) {
      const { payload, label } = props;
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "rgba(100,100,100,0.8)",
            color: "white",
            padding: "3px",
            borderRadius: "5px",
          }}
        >
          <p className="label">{`${label} : ${payload[0].value.toLocaleString(
            "pl-PL",
            { maximumFractionDigits: 0 }
          )}`}</p>
        </div>
      );
    } else return null;
  };

  return (
    <Paper
      style={{
        minWidth: "410px",
        width: "100%",
        padding: "5px",
        marginBottom: "10px",
        marginRight: "0px",
      }}
    >
      <Typography
        style={{
          color: "#0b6471",
          fontSize: "16px",
          fontWeight: "100",
          borderBottom: "0px solid",
          paddingLeft: "10px",
          paddingTop: "5px",
        }}
      >
        KLUCZ PODZIAŁOWY OPK POMOCNICZEGO
      </Typography>

      <TableContainer>
        <Table size="small" style={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                }}
              >
                Klucz
              </TableCell>
              <TableCell
                align="center"
                colSpan='2'
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                }}
              >
                WYK Liczba jednostek klucza
              </TableCell>

              <TableCell
                align="center"
                colSpan='2'
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                }}
              >
                WYK Stawka kosztów na jednostkę
              </TableCell>
              <TableCell
                align="center"
                colSpan='2'
                style={{
                  color: "#0b6471",
                  fontSize: "16px",
                  fontWeight: "100",
                }}
              >
                WYK Koszt rozliczony
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {row &&
              row
                .map((child) => (
                  <TableRow key={child.opk_id}>
                    <TableCell component="th" scope="row">
                      {child.driver}
                    </TableCell>
                    <TableCell align="right">
                      {child.wqty.toLocaleString("pl-PL", {
                        maximumFractionDigits: 0,
                      })}
                    </TableCell>
                    <TableCell style={{ padding: "0px" }}>
                      <div
                        style={{
                          height: "40px",
                          width: "130px",
                          padding: "0px",
                        }}
                      >
                        <ResponsiveContainer>
                          <BarChart
                            style={{ padding: "0px", margin: "0px" }}
                            width={250}
                            height={60}
                            data={child.monthly}
                          >
                            <Tooltip content={<CustomTooltip />} />
                            <XAxis dataKey="MONTH" hide={true} />
                            <Bar
                              dataKey="wqty"
                              fill="#0B6471"
                              barSize={250 / (1.5 * 12)}
                            >
                              {child.monthly.map((entry, index) => (
                                <Cell
                                  cursor="pointer"
                                  fill={entry.wqty < 0 ? "#FE8E3C" : "#0B6471"}
                                />
                              ))}
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      {child.rate.toLocaleString("pl-PL", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                      })}
                    </TableCell>
                    <TableCell style={{ padding: "0px" }}>
                      <div
                        style={{
                          height: "40px",
                          width: "130px",
                          padding: "0px",
                        }}
                      >
                        <ResponsiveContainer>
                          <BarChart
                            style={{ padding: "0px", margin: "0px" }}
                            width={250}
                            height={60}
                            data={child.monthly}
                          >
                            <Tooltip content={<CustomTooltip />} />
                            <XAxis dataKey="MONTH" hide={true} />
                            <Bar
                              dataKey="rate"
                              fill="#4E97A5"
                              barSize={250 / (1.5 * 12)}
                            >
                              {child.monthly.map((entry, index) => (
                                <Cell
                                  cursor="pointer"
                                  fill={entry.rate < 0 ? "#FE8E3C" : "#4E97A5  "}
                                />
                              ))}
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      {(child.cost).toLocaleString("pl-PL", {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                      })}
                    </TableCell>
                    <TableCell style={{ padding: "0px" }}>
                      <div
                        style={{
                          height: "40px",
                          width: "130px",
                          padding: "0px",
                        }}
                      >
                        <ResponsiveContainer>
                          <BarChart
                            style={{ padding: "0px", margin: "0px" }}
                            width={250}
                            height={60}
                            data={child.monthly}
                          >
                            <Tooltip content={<CustomTooltip />} />
                            <XAxis dataKey="MONTH" hide={true} />
                            <Bar
                              dataKey='cost'
                              fill="#4E97A5"
                              barSize={250 / (1.5 * 12)}
                            >
                              {child.monthly.map((entry, index) => (
                                <Cell
                                  cursor="pointer"
                                  fill={entry.rate < 0 ? "#FE8E3C" : "#4E97A5  "}
                                />
                              ))}
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default function Report006() {
  const [yardList, setYardList] = React.useState([]);
  const [yardListLoaded, setYardListLoaded] = React.useState(false);
  const [activeYard, setActiveYard] = React.useState(null);
  const [reportDataLoaded, setReportDataLoaded] = React.useState(false);
  const [reportData, setReportData] = React.useState(null);
  const [filtersLoaded, setFiltersLoaded] = React.useState(false);
  const [dateList, setDateList] = React.useState([]);
  const [startDate, setStartDate] = React.useState(null);
  const { getAccessTokenSilently, user } = useAuth0();
  const [selectedMonths, setSelectedMonths] = React.useState([]);

  const [videoListOpen, setVideoListOpen] = React.useState(false);
  const [videoPlayDialogOpen, setVideoPlayDialogOpen] = React.useState(false);

  const handleVideoListClose = () => {
    setVideoListOpen(false)
};

const videoData = [
    {
        image: '/manual/reports/Raport OPK pomocnicze.jpg',
        video: '/manual/reports/Raport OPK pomocnicze.mp4'
    },
];

const [selectedVideo, setSelectedVideo] = React.useState(videoData[0]);

const handleVideoSelect = (video) => {
    setSelectedVideo(video);
    setVideoListOpen(false);
    setVideoPlayDialogOpen(true);
};

const VideoList = () => {
    return <div>
        {
            videoData.map(
                (v, i) => {
                    return <div className="videoListItem" onClick={() => handleVideoSelect(v)}>
                        <div style={{ position: 'relative' }}>
                            <img src={v.image} alt={'Video nr ' + i} />
                            <div style={{
                                position: 'absolute',
                                top: '90px',
                                left: '190px',
                                opacity: '.5',
                                color: 'gray'
                            }}>
                                <PlayIcon />
                            </div>
                        </div>
                    </div>
                }
            )
        }
    </div>
}


  const loadData = (opk, year, months) => {
    setActiveYard(opk);
    setReportDataLoaded(false);

    const currentMonths = months ? months : selectedMonths;

    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(`${apiurl}/supportunitdetails/${opk.opk_id}/${year}/${JSON.stringify(currentMonths)}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          setReportData(data);
          //console.log(`${apiurl}/supportunitdetails/${opk.opk_id}/${year}/${currentMonths}`);
          //console.log("Report data loaded");
          setReportDataLoaded(true);
        });
    });
  }

  function ComboBox(props) {
    return (
      <Autocomplete
        id="yard-combo-box"
        options={props.data ?? []}
        value={activeYard ?? null}
        size="small"
        disableClearable
        autoHighlight
        getOptionLabel={(option) => option?.opk_name ?? ""}
        isOptionEqualToValue={(option, value) =>
          option?.opk_name === value?.opk_name
        }
        style={{ width: "550px", marginBottom: "10px" }}
        renderInput={(params) => (
          <TextField {...params} label="Komórka" InputLabelProps={{ shrink: true }} />
        )}
        onChange={(event, value) => {
          if (value && startDate?.year) {
            loadData(value, startDate.year);
          }
        }}
      />
    );
  }

  function loadDataWithMonths(year, months) {
    activeYard && loadData(activeYard, year, months)
  }

  function DateBox(props) {
    return (
      <Autocomplete
        id="combo-box"
        disabled={!props.data}
        options={props.data}
        value={startDate}
        size="small"
        disableClearable
        autoHighlight
        getOptionLabel={(option) => option.year && option.year.toLocaleString()}
        
        getOptionSelected={(option, value) => {
          if (!value) return false;
          return option.year.toLocaleString() === value;
        }}
        style={{ width: "80px", marginBottom: "10px", marginLeft: '10px', marginRight: '10px' }}
        renderInput={(params) => <TextField {...params} label="Rok" InputLabelProps={{ shrink: true }}/>}
        onChange={(event, value) => {
          if (value) {
            setStartDate(value);
            if (activeYard) loadData(activeYard, value.year);
          }
        }}
      />
    );
  }

  const loadFilters = () => {
    setFiltersLoaded(false);
    const apiUrl = `${apiurl}/yearslist`;
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          setDateList(fetchedData.datelist);
          if (fetchedData.datelist && fetchedData.datelist.length !== 0) {
            setStartDate(fetchedData.datelist[fetchedData.datelist.length - 1]);
            //loadData(fetchedData.datelist[fetchedData.datelist.length - 1].year);
            setFiltersLoaded(true);
          }
        });
    });
  }

  const loadYardList = (year) => {
    // setYardListLoaded(false);
    const apiUrl = `${apiurl}/supportunitlist/${year}`;
  
    getAccessTokenSilently().then((token) => {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      };
  
      fetch(apiUrl, requestOptions)
        .then((res) => res.json())
        .then((fetchedData) => {
          setYardList(fetchedData);
  
          setActiveYard((prevActiveYard) => {
            if (!prevActiveYard) return undefined;
  
            const stillExists = fetchedData.some(
              (yard) => yard.opk_id === prevActiveYard.opk_id
            );
            return stillExists ? prevActiveYard : undefined;
          });
  
          setYardListLoaded(true);
        });
    });
  };


  React.useEffect(() => {
    loadFilters();
  }, []);
  
  React.useEffect(() => {
    if (startDate) {
      loadYardList(startDate.year);
    }
  }, [startDate]);
  
  // React.useEffect(() => {
  //   let mounted = true;
  //   //console.log("Main mounted");
  //   setYardListLoaded(false);
  //   const apiUrl = `${apiurl}/supportunitlist`;
  //   getAccessTokenSilently().then((token) => {
  //     const requestOptions = {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: "Bearer " + token,
  //       },
  //     };
  //     fetch(apiUrl, requestOptions)
  //       .then((res) => res.json())
  //       .then((fetchedData) => {
  //         if (mounted) {
  //           setYardList(fetchedData);
  //           loadFilters();
  //           setYardListLoaded(true);
  //         }
  //       });
  //   });
  //   return function cleanup() {
  //     //console.log("Main unmounted");
  //     mounted = false;
  //   };
  // }, []);

  return (
    <div className="App" style={{ position: "relative" }}>
      <div
        style={{
          background: "linear-gradient(to right, #0b6471, #0b6471)",
          display: "flex",
          height: "65px",
          width: "100%",
          backgroundColor: "#0b6471",
          color: "white",
          borderRadius: "5px",
          paddingTop: "0px",
          paddingLeft: "0px",
          alignItems: "center",
        }}
      >
        <div style={{ width: "80px", marginTop: "5px" }}>
          <PollIcon
            style={{
              marginLeft: "20px",
              marginRight: "20px",
              fontSize: "42px",
            }}
          />
        </div>
        <div>
          <Typography variant="h5" style={{ color: "white" }}>
            Analiza OPK Pomocniczego
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ fontWeight: "300", color: "white" }}
          >
            (BU, WYK) w zł.
          </Typography>
        </div>
      </div>
      <p style={{ height: "5px" }} />
      {yardListLoaded ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            position: "relative",
            width: "100%",
          }}
        >
          <ComboBox data={yardList} />
          <DateBox data={dateList} />
          <MonthSelect setSelectedMonthsFunction={setSelectedMonths} loadDataFunction={loadDataWithMonths} selectedMonthsProperty={selectedMonths} startDateProperty={startDate} />
          <MUITooltip title='Opis raportu'>
            <a edge='end' style={{ marginTop: '14px', marginLeft: '10px', marginRight: '7px', color: '#0b6471' }} target='_blank' href='/usermanual/opis_raportu_003'>
              <ImportContactsIcon />
            </a>
          </MUITooltip>
          
            <MUITooltip title='Instrukcje video'>
              <Button
                id='video'
                onClick={
                  () => setVideoPlayDialogOpen(true)
                }
                style={{
                  marginTop: "0px",
                  width: "48px",
                  minWidth: "48px",
                  height: "52px",
                  color: "#0B6471",
                  borderRadius: "5px",
                  marginRight: '10px',
                }}
              > <sup style={{ position: 'absolute', color: '#FE8E3C', fontWeight: 'bold', top: '0px', left: '4px' }}>N</sup>
                <VideoIcon
                  style={{ color: '#0B6471', marginTop: '2px', cursor: 'pointer' }}
                />
              </Button>
            </MUITooltip>
         

        </div>
      ) : (
        <div>List not yet loaded</div>
      )}
      <p style={{ height: "5px" }} />

      {activeYard && reportData && reportData.yearlydata.cost ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            overflow: "auto",
            transition: "opacity 0.5s",
            opacity: reportDataLoaded ? "1" : "0.2",
          }}
        >
          <div
            id="top chart area"
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <div
              id="tiny charts area"
              style={{
                display: "flex",
                flexWrap: "nowrap",
                width: "100%",
                flexDirection: "row",
                flexShrink: 1,
              }}
            >
              <Paper style={{ marginRight: '10px', marginBottom: '10px' }}>
                <TinyChart
                  title="KOSZTY"
                  marginBottom='0px'
                  marginRight='0px'
                  height='100%'
                  data={reportData}
                  datatype="cost"
                  actual={
                    reportData.yearlydata && reportData.yearlydata.cost && reportData.yearlydata.cost.toLocaleString("pl-PL", {
                      maximumFractionDigits: 0,
                    }) + " zł"
                  }
                  budget={
                    reportData.budgetData && reportData.budgetData.cost_BU && reportData.budgetdata.cost_BU.toLocaleString("pl-PL", {
                      maximumFractionDigits: 0,
                    }) + "%"
                  }
                  color="#0B6471"
                />
              </Paper>
              <ProfitTable
                title="RANKING KOSZTÓW WYNAGRODZEŃ WG GRUP PRACOWNICZYCH"
                data={reportData.salaries_by_group}
                dataType="cost"
                columns={[
                  {
                    name: "Grupa pracownicza",
                    align: "left",
                    style: { color: "#0b6471", borderBottom: "1px solid" },
                    datadef: "group_name",
                    datalen: "",
                  },
                  {
                    name: "BU",
                    align: "right",
                    style: { color: "#0b6471", borderBottom: "5px double" },
                    datadef: "cost_bu",
                    datalen: 0,
                  },
                  {
                    name: "Δ %",
                    align: "right",
                    style: { color: "#0b6471", borderBottom: "1px solid" },
                    datadef: "cost_delta",
                    datalen: 2,
                  },
                  {
                    name: "Koszt wynagrodzeń",
                    align: "right",
                    style: { color: "#0b6471", borderBottom: "4px solid" },
                    datadef: "cost",
                    datalen: 0,
                  },
                ]}
              />
            </div>
          </div>
          <OPKTable2 data={reportData} />
          {reportData.driver_summary && <DriverSummary row={reportData.driver_summary} />}
          {reportData.driver_summary_1 && <DriverSummary row={reportData.driver_summary_1} />}
          {reportData.driver_by_destination && <DriverTargets row={reportData.driver_by_destination} />}
          {reportData.driver_by_destination_1 && <DriverTargets row={reportData.driver_by_destination_1} />}
        </div>
      ) : (
        !activeYard && (
          <Typography
            style={{
              position: "absolute",
              top: "120%",
              left: "40%",
              color: "#0b6471",
              textJustify: "left"
            }}
            variant="h5"
          >
            Wybierz komórkę
          </Typography>
        )
      )}
      {!reportDataLoaded && activeYard && (
        <CircularProgress
          style={{
            position: "absolute",
            height: "70px",
            width: "70px",
            top: reportData ? "50%" : "120%",
            left: "50%",
            color: "#0b6471",
            opacity: "0.6",
          }}
        />
      )}

<Popover
                id='videoSelectPopOver'
                open={reportDataLoaded && videoListOpen}
                anchorEl={document.getElementById('video')}
                onClose={handleVideoListClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
            >
                <Paper
                    style={{
                        padding: "10px",
                        width: "450px",
                        fontFamily: "roboto",
                        display: "flex",
                        flexDirection: "column",
                        //height: 'calc(100vh - 270px)'
                    }}
                >

                    <div
                        style={{
                            top: "0px",
                            display: "flex",
                            width: "100%",
                            justifyContent: "right"
                        }}
                    >

                        <CloseIcon style={{ cursor: 'pointer', fontSize: '16px' }} onClick={() => handleVideoListClose()} />

                    </div>

                    <VideoList />

                </Paper>
            </Popover>
            <Dialog

                maxWidth='90vw'
                open={videoPlayDialogOpen}
                onClose={() => setVideoPlayDialogOpen(false)}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"

            >
                <DialogContent style={{ display: 'flex', flexDirection: 'column', margin: '0px', padding: '0px' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '3px 10px 3px 0px' }}>
                        <button
                            onClick={() => {
                                const div = document.getElementById('videoControl');
                                if (div.requestFullscreen)
                                    div.requestFullscreen();
                                else if (div.webkitRequestFullscreen)
                                    div.webkitRequestFullscreen();
                                else if (div.msRequestFullScreen)
                                    div.msRequestFullScreen();
                            }
                            }
                            style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
                        >
                            Pełen ekran
                        </button>
                        <button
                            onClick={() => setVideoPlayDialogOpen(false)}
                            style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
                        >
                            Zamknij
                        </button>
                    </div>
                    <video id='videoControl' controls autoPlay style={{ width: '80vw' }}>
                        <source src={selectedVideo && selectedVideo.video} type="video/mp4" />
                        Video control not supported by browser
                    </video>

                </DialogContent>
            </Dialog>

    </div>
  );
}
